module.exports = __webpack_public_path__ + "static/media/bordePiña.fc8abfde.jpg";